import { PlusStatus } from "./plusStatus";

const determineWebPlusAdVisibility = (
  data: PlusStatus | null,
  freeviewPromotionNumber?: number,
) => {
  let hasFreeview = false;
  if (freeviewPromotionNumber) {
    hasFreeview = freeviewPromotionNumber > 0;
  }

  if (data !== null) {
    const isPlusMember = data?.isPlusMember ?? false;
    const actualSavings = data?.actualSavings ?? 0;
    const estimatedSubCost = data?.estimatedSubscriptionCost ?? 0;
    const savingMoreThanEstimatedCost = actualSavings > estimatedSubCost;

    if (
      !isPlusMember ||
      (savingMoreThanEstimatedCost && (isPlusMember || hasFreeview))
    ) {
      return true;
    }
  }

  return false;
};

export default determineWebPlusAdVisibility;
